import { isAgentDisplayState } from "./store.js";
import { formatSlotLabel } from "./booking/format.js";
export function applyDataChannelMessage(store, data) {
    const st = store.getState();
    switch (data.type) {
        case "llm_metrics":
            if (data.ttftMs > 0)
                st.addPipelineMetric("llmTtft", data.ttftMs);
            if (data.durationMs > 0)
                st.addPipelineMetric("llmDuration", data.durationMs);
            if (data.tokensPerSecond > 0)
                st.addPipelineMetric("llmTokensPerSecond", data.tokensPerSecond);
            if (data.promptTokens > 0)
                st.addPipelineMetric("llmPromptTokens", data.promptTokens);
            if (data.completionTokens > 0)
                st.addPipelineMetric("llmCompletionTokens", data.completionTokens);
            break;
        case "tts_metrics":
            if (data.ttfbMs > 0)
                st.addPipelineMetric("ttsTtfb", data.ttfbMs);
            if (data.durationMs > 0)
                st.addPipelineMetric("ttsDuration", data.durationMs);
            if (data.audioDurationMs > 0)
                st.addPipelineMetric("ttsAudioDuration", data.audioDurationMs);
            if (data.charactersCount > 0)
                st.addPipelineMetric("ttsCharactersCount", data.charactersCount);
            break;
        case "stt_metrics":
            if (data.durationMs > 0)
                st.addPipelineMetric("sttDuration", data.durationMs);
            if (data.audioDurationMs > 0)
                st.addPipelineMetric("sttAudioDuration", data.audioDurationMs);
            break;
        case "eou_metrics":
            if (data.endOfUtteranceDelayMs > 0)
                st.addPipelineMetric("eouDelay", data.endOfUtteranceDelayMs);
            if (data.transcriptionDelayMs > 0)
                st.addPipelineMetric("eouTranscriptionDelay", data.transcriptionDelayMs);
            break;
        case "vad_metrics":
            if (data.idleTimeMs > 0)
                st.addPipelineMetric("vadIdleTime", data.idleTimeMs);
            if (data.inferenceDurationTotalMs > 0)
                st.addPipelineMetric("vadInferenceDuration", data.inferenceDurationTotalMs);
            if (data.inferenceCount > 0)
                st.addPipelineMetric("vadInferenceCount", data.inferenceCount);
            break;
        case "retrieval_latency":
            if (data.latency > 0)
                st.addPipelineMetric("retrievalLatency", data.latency);
            break;
        case "agent_state_changed": {
            // The answer-edge check reads lastAgentStateEvent, which only this
            // reducer writes, rather than agentDisplayState: a host embed can also
            // write agentDisplayState (e.g. from LiveKit's lk.agent.state
            // participant attribute), and its writes typically land before this
            // data-channel message, which would otherwise mask the edge.
            const prevAgentStateEvent = st.lastAgentStateEvent;
            const connectionMap = {
                initializing: "connecting",
                idle: "connected",
                listening: "connected",
                thinking: "connected",
                speaking: "connected",
            };
            st.setConnectionState(connectionMap[data.new_state] ?? "connected");
            const normalized = isAgentDisplayState(data.new_state) ? data.new_state : "idle";
            st.setAgentDisplayState(normalized);
            st.setLastAgentStateEvent(normalized);
            if (prevAgentStateEvent === "speaking" &&
                (normalized === "listening" || normalized === "idle")) {
                st.noteAgentAnswerEdge();
            }
            break;
        }
        case "transcript_item":
            if (data.text) {
                st.addTranscriptItem({
                    role: data.role,
                    text: data.text,
                    timestamp: data.timestamp ?? Date.now(),
                });
            }
            if (data.role === "user")
                st.noteUserTurn();
            break;
        case "show_booking_form":
            st.setBookingOpen(true);
            break;
        case "show_booking_times":
            st.setBookingOpen(true);
            st.setBookingStep(1);
            break;
        case "slot_selected": {
            st.setBookingOpen(true);
            const slots = st.slots;
            const slotLabel = slots
                ? (() => {
                    const allSlots = Object.values(slots).flat();
                    const match = allSlots.find((s) => s.start === data.start);
                    return match ? formatSlotLabel(match.start) : formatSlotLabel(data.start);
                })()
                : formatSlotLabel(data.start);
            st.setSelectedStart(data.start, slotLabel);
            st.setBookingStep(2);
            break;
        }
        case "human_handoff_requested":
            st.setHandoffState("idle", data.handoff_id, null);
            break;
        case "human_handoff_joined":
            st.setHandoffState("joined", data.handoff_id, data.operator_name ?? null);
            break;
        case "human_handoff_unavailable":
            st.setHandoffState("unavailable", data.handoff_id, null);
            break;
    }
}
